export const ACCOUNT_SETUP = '/account-setup'

const accountSetupRoutes = [ACCOUNT_SETUP]

export default accountSetupRoutes
